import { Mui, MuiIcons } from "@osu/react-ui";
import React, { useEffect, useRef } from "react";
import { Fragment } from "react";

const buttonProgressSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -12,
  marginLeft: -12,
};

const id = 'error-alert'

function ErrorAlert({ title, onClick, message = '', status, style, action = {}, severity, ...rest } = {}) {
  const loading = status === 'loading'
  const defaultActionText = loading ? 'Retrying' : 'Retry'
  const defaultIcon = loading ? null : <MuiIcons.Refresh />
  const { startIcon = defaultIcon, text = defaultActionText, ...restOfAction } = action;
  const ref = useRef()
  const success = status === 'success'
  const finalSeverity = severity ? severity : success ? 'success' : 'error'
  
  useEffect(() => {    
    if (
      message 
      && ref.current instanceof Element 
      && document?.activeElement?.id !== id
    ) {
      ref.current.focus();
    }
  }, [message]);

  let Component = Mui.Box;
  let componentProps = {};
  if (message) {
    Component = Mui.Alert;
    componentProps = {
      ...componentProps,
      ...rest,
      severity: finalSeverity
    }
    if (text && onClick) {
      componentProps.action = (
        <Mui.Button
          disabled={loading}
          startIcon={startIcon}
          onClick={onClick}
          color="inherit"
          size="small"
          {...restOfAction}
        >
          {text}
          {loading && <Mui.CircularProgress size={24} sx={buttonProgressSx} />}
        </Mui.Button>
      );
    }
  }

  return (
    <Component 
        className="margin-bottom-2" autoFocus id={id} tabIndex={-1} ref={ref} role="alert" aria-live="polite" {...componentProps} >
      {message && (
        <Fragment>
          {title && <Mui.AlertTitle>{title}</Mui.AlertTitle>}
          <Mui.Typography style={style}>
          {message}
          </Mui.Typography>
        </Fragment>
      )}
    </Component>
  );
}

export default ErrorAlert;
